"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAcceptanceTemplateName = exports.CustomerSegment = exports.SalesChannel = exports.CONTRACT_ROUTE_TO_MARKET = exports.CONTRACT_MODEL = exports.CONTRACT_BUYING_PROGRAM = void 0;
exports.CONTRACT_BUYING_PROGRAM = {
  ENTERPRISE_PRODUCT: 'ENTERPRISE_PRODUCT',
  ETLA: 'ETLA',
  FREE: 'FREE',
  VIP: 'VIP',
  VIPMP: 'VIPMP'
};
exports.CONTRACT_MODEL = {
  // Contract Service
  ALLOCATION: 'ALLOCATION',
  CLASSROOM: 'CLASSROOM',
  RESELLER: 'RESELLER',
  STANDARD: 'STANDARD',
  TRIAL: 'TRIAL'
};
exports.CONTRACT_ROUTE_TO_MARKET = {
  DIRECT: 'DIRECT',
  ENTERPRISE: 'ENTERPRISE',
  INDIRECT: 'INDIRECT'
};
var SalesChannel;

(function (SalesChannel) {
  SalesChannel["DIRECT"] = "DIRECT";
  SalesChannel["INDIRECT"] = "INDIRECT";
})(SalesChannel = exports.SalesChannel || (exports.SalesChannel = {}));

var CustomerSegment;

(function (CustomerSegment) {
  CustomerSegment["ENTERPRISE"] = "ENTERPRISE";
  CustomerSegment["TEAM"] = "TEAM";
})(CustomerSegment = exports.CustomerSegment || (exports.CustomerSegment = {}));

var TermsAcceptanceTemplateName;

(function (TermsAcceptanceTemplateName) {
  TermsAcceptanceTemplateName["VIP"] = "tc_vip_indirect";
  TermsAcceptanceTemplateName["VIPMP"] = "tc_vipmp_indirect";
})(TermsAcceptanceTemplateName = exports.TermsAcceptanceTemplateName || (exports.TermsAcceptanceTemplateName = {}));